import { Container } from 'reactstrap';
export default function ErrorMessage({
  message
}) {
  return <Container data-sentry-element="Container" data-sentry-component="ErrorMessage" data-sentry-source-file="ErrorMessage.tsx">
      <h2 className="p-5">{message}</h2>
    </Container>;
}